import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'
import i18n from '@/VueI18n'

export class CantRelateFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super(
			i18n.t('fireRiskDashboardReactionUndetermined') as string,
			'fa7-solid:question',
			FireOutbreakReactionEnum.IMPOSSIBLE,
		)
	}
}
